import loadable, { FallbackLoader } from 'components/utils/lazyImport'

export const OriginalFooter = loadable(() => import(/* webpackChunkName: "OriginalFooter" */ './OriginalFooter'), <FallbackLoader inline />)

export const CompactFooter = loadable(() => import(/* webpackChunkName: "CompactFooter" */ './CompactFooter'), <FallbackLoader inline />)
